import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

const LABEL_NEVER = "Never";

const ago = (isoDate?: string, shouldReturnNever = false): string => {
  if (isoDate) {
    const relative = dayjs(isoDate).fromNow();

    return relative;
  }

  const fallback = shouldReturnNever
    ? LABEL_NEVER
    : "";

  return fallback;
};

export default ago;
